import React from 'react';

import ConflictCard from '@/components/reconciliation/ConflictCard';
import DeleteRequestCard from '@/components/reconciliation/DeleteRequestCard';

export default function WorklistOrderChangeDetail({
  record,
  conflictActions,
  deletionActions,
  isAdmin,
}) {
  const mutationId = record.source?.mutation?.id || record.id;

  if (record.kind === 'deletion') {
    return (
      <div data-testid={`worklist-deletion-${mutationId}`}>
        {!isAdmin && (
          <div className="mb-4 rounded-lg border border-stone-300 bg-stone-50 p-3 text-sm text-stone-600">
            An administrator must decide whether to permanently delete or keep this order.
          </div>
        )}
        <DeleteRequestCard
          item={record.source}
          isAdmin={isAdmin}
          resolvingId={deletionActions.resolvingId}
          onApprove={deletionActions.onApprove}
          onReject={deletionActions.onReject}
        />
      </div>
    );
  }

  return (
    <div data-testid={`worklist-order-change-${mutationId}`}>
      <ConflictCard
        item={record.source}
        isAdmin={isAdmin}
        resolvingId={conflictActions.resolvingId}
        onUseOfflineChange={conflictActions.onUseOfflineChange}
        onDiscard={conflictActions.onDiscard}
        userNames={conflictActions.userNames}
        actionLabels={{
          apply: 'Replace newer online change',
          discard: 'Discard offline change',
        }}
      />
    </div>
  );
}
